module.exports = __webpack_public_path__ + "img/17a003-08.3a7cdebd.png";